import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, message, Popconfirm, Tag } from 'antd';
import { Route, Switch } from "react-router-dom";

import List from '../../components/List';
import Create from './create';
import View from './view';
import TripActionModal from './TripActionModal';
import StatusUpdateModal from './StatusUpdateModal';
import {
  createResource,
  updateResource,
  deleteResource,
  fetchResource,
  getResource,
  saveResourceQuery,
  getResourceForDownload,
  startTrip,
  endTrip,
  addStatus
} from "../../appRedux/actions/FleetTrip";
import { fetchFilter, searchGlobalAssetData } from '../../appRedux/actions';
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName,
} from '../../util/methods'
import AccessControl from "../../components/AccessControl";
import * as _ from 'lodash';

const CAN_START = ['DRAFT', 'PLANNED', 'ASSIGNED', 'PAUSED'];
const CAN_END = ['STARTED', 'PAUSED'];
const STATUS_COLORS = {
  DRAFT: 'default', PLANNED: 'blue', ASSIGNED: 'cyan', STARTED: 'green',
  PAUSED: 'orange', COMPLETED: 'geekblue', CANCELLED: 'red'
};

export class FleetTrip extends Component {
  initialQueryState = {
    sort: { field: '', order: '' },
    pagination: { pageSize: 10, current: 1 },
    filters: {},
  };

  state = {
    fields: {},
    query: this.initialQueryState,
    columns: [],
    visibleColumns: [],
    actionModalVisible: false,
    actionMode: 'start',
    actionTrip: null,
    statusModalVisible: false,
    statusTrip: null
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) => Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
      this.setState({ visibleColumns: columns }, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      })
    }
  }

  handleColumnChange = (value) => {
    this.renderColumns(this.props.filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = { ...this.props.query };
    query.filters[data.field] = JSON.stringify({ value: selectedKeys, type: data.type, field: data.field });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = { ...this.props.query };
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = { ...this.props.query };
    query.pagination = { ...query.pagination, current: pagination.current };
    query.sort = sorter;
    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = (changedFields) => {
    this.setState(({ fields }) => ({ fields: { ...fields, ...changedFields } }));
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const { resourceName } = this.props;

    Object.keys(filters).forEach((item) => {
      if (item === '_id') return;
      if (selectedColumns.indexOf(item) === -1) return;

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => item === 'tripStatus'
          ? <Tag color={STATUS_COLORS[value] || 'default'}>{value}</Tag>
          : getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => {
        const canStart = CAN_START.includes(record.tripStatus);
        const canEnd = CAN_END.includes(record.tripStatus);
        const isClosed = record.tripStatus === 'COMPLETED' || record.tripStatus === 'CANCELLED';
        const canDelete = record.tripStatus === 'PLANNED';
        return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            <Button type="primary" size='small' onClick={() => this.view(record._id)}>View</Button>

            <AccessControl resource={resourceName} permissionNeeded={'u'}
              roles={this.props.authUser ? this.props.authUser.roles : []} render={() =>
                <Button size='small' onClick={() => this.edit(record._id)}>Edit</Button>} />

            <AccessControl resource={resourceName} permissionNeeded={'u'}
              roles={this.props.authUser ? this.props.authUser.roles : []} render={() =>
                <Button type='primary' size='small' disabled={!canStart} onClick={() => this.openAction('start', record)}>Start</Button>} />

            <AccessControl resource={resourceName} permissionNeeded={'u'}
              roles={this.props.authUser ? this.props.authUser.roles : []} render={() =>
                <Button type='danger' ghost size='small' disabled={!canEnd} onClick={() => this.openAction('end', record)}>End</Button>} />

            <AccessControl resource={resourceName} permissionNeeded={'u'}
              roles={this.props.authUser ? this.props.authUser.roles : []} render={() =>
                <Button size='small' disabled={isClosed} onClick={() => this.openStatus(record)}>Status</Button>} />

            <AccessControl resource={resourceName} permissionNeeded={'d'}
              roles={this.props.authUser ? this.props.authUser.roles : []} render={() =>
                canDelete
                  ? <Popconfirm title="Delete this trip?" onConfirm={() => this.deleteResource(record._id)} okText="Yes" cancelText="No">
                    <Button type="danger" size='small'>Delete</Button>
                  </Popconfirm>
                  : <Button type="danger" size='small' disabled title='Only PLANNED trips can be deleted'>Delete</Button>} />
          </div>
        )
      },
    });

    this.setState({ visibleColumns: selectedColumns, columns })
  };

  clearAll = () => {
    this.props.saveResourceQuery({
      sort: { field: '', order: '' },
      pagination: { pageSize: 10, current: 1 },
      filters: {},
    });
    this.fetchList();
  };

  fetchList = () => this.props.getResource();
  createResource = (values) => this.props.createResource(values);
  updateResource = (values, id) => this.props.updateResource(values, id);
  deleteResource = (id) => this.props.deleteResource(id);

  create = () => this.props.history.push(`${this.props.match.url}/add`);
  view = (id) => this.props.history.push(`${this.props.match.url}/view/${id}`);
  edit = (id) => this.props.history.push(`${this.props.match.url}/edit/${id}`);

  openAction = (mode, trip) => {
    this.setState({ actionModalVisible: true, actionMode: mode, actionTrip: trip });
  };

  closeAction = () => {
    this.setState({ actionModalVisible: false, actionTrip: null });
  };

  submitAction = (payload) => {
    const { actionMode, actionTrip } = this.state;
    if (!actionTrip) return;
    if (actionMode === 'start') {
      this.props.startTrip(actionTrip._id, payload);
    } else {
      this.props.endTrip(actionTrip._id, payload);
    }
    this.closeAction();
  };

  openStatus = (trip) => {
    this.setState({ statusModalVisible: true, statusTrip: trip });
  };

  closeStatus = () => {
    this.setState({ statusModalVisible: false, statusTrip: null });
  };

  submitStatus = (payload) => {
    const { statusTrip } = this.state;
    if (!statusTrip) return;
    this.props.addStatus(statusTrip._id, payload);
    this.closeStatus();
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.forEach(column => column.title !== "Action" && columns.push(_.camelCase(column.title)));
    this.props.getResourceForDownload(JSON.stringify(columns), this.props.filters, "FleetTrip");
  };

  render() {
    const { match, data, loading, filters, modules, authUser, resourceName } = this.props;
    const { columns, visibleColumns } = this.state;
    faviconDynamicFunction(authUser);

    return (<div>
      {/* <h2>{sanitizeFieldName(resourceName)}</h2> */}

      <Switch>
        <Route path={`${match.url}`} exact
          render={() => <React.Fragment>
            <List columns={columns}
              visibleColumn={visibleColumns}
              data={data}
              clearFilter={this.clearAll}
              filters={filters}
              handleChange={this.handleChange}
              columnChange={this.handleColumnChange}
              downloadToCSV={this.downloadToCSV}
              title={resourceName}
              size={'middle'}
              create={this.create}
              pagination={this.props.query.pagination}
              loading={loading}
              authUser={authUser}
            />
            <TripActionModal
              visible={this.state.actionModalVisible}
              mode={this.state.actionMode}
              trip={this.state.actionTrip}
              loading={loading}
              onSubmit={this.submitAction}
              onCancel={this.closeAction}
            />
            <StatusUpdateModal
              visible={this.state.statusModalVisible}
              trip={this.state.statusTrip}
              manpowerOptions={(filters && filters['manpower'] && filters['manpower'].data && filters['manpower'].data.data) || []}
              loading={loading}
              onSubmit={this.submitStatus}
              onCancel={this.closeStatus}
            />
          </React.Fragment>
          } />
        <Route path={`${match.url}/add`}
          render={(props) => <Create data={{}}
            filters={filters}
            modules={modules}
            title={'CREATE'}
            resource={resourceName}
            onChange={this.handleFormChange}
            onSubmit={this.createResource}
            loading={loading}
            assetData={this.props.assetData}
            assetSearchLoading={this.props.assetSearchLoading}
            searchGlobalAssetData={this.props.searchGlobalAssetData}
            authUser={authUser}
            {...props}
          />
          } />
        <Route path={`${match.url}/edit/:id`}
          render={(props) => <Create data={this.props.edit}
            filters={filters}
            modules={modules}
            title={'EDIT'}
            resource={resourceName}
            fetch={this.props.fetchResource}
            onChange={this.handleFormChange}
            onSubmit={this.updateResource}
            loading={loading}
            assetData={this.props.assetData}
            assetSearchLoading={this.props.assetSearchLoading}
            searchGlobalAssetData={this.props.searchGlobalAssetData}
            authUser={authUser}
            {...props}
          />
          } />
        <Route path={`${match.url}/view/:id`}
          render={(props) => <View data={this.props.edit} fetch={this.props.fetchResource} loading={loading} {...props} />} />
      </Switch>
    </div>)
  }
}

const mapStateToProps = ({ auth, fleetTrip, commonData }) => {
  return {
    authUser: auth.authUser,
    total: fleetTrip.total,
    data: fleetTrip.resources,
    resource: fleetTrip.resource,
    edit: fleetTrip.edit,
    query: fleetTrip.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    assetData: commonData.assetSearchData,
    assetSearchLoading: commonData.assetSearchLoading,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    updateResource,
    fetchResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    searchGlobalAssetData,
    startTrip,
    endTrip,
    addStatus
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(FleetTrip);
